import { VersionMetadata } from 'api/model';
import instance from '../axios_instance';

export const getVersionMetadata = async (): Promise<VersionMetadata> => {
  const response = await instance.get<VersionMetadata>('/version');
  return response.data;
};
